import styled from 'styled-components';

export const ActionBtn = styled.div`
width: 100%;
box-sizing; border-box;
margin: 15px 0;
`;